import React from 'react';
import { useStyletron } from 'baseui';
import { Card, StyledBody } from 'baseui/card';
import { Tag, KIND } from 'baseui/tag';
import { IBusinessRule } from '../../../utils/types';
import RiskBadge from '../../../components/RiskBadge';

interface RulesTabProps {
	rules: IBusinessRule[];
}

const CATEGORY_KIND: Record<string, string> = {
	compliance: KIND.negative,
	'business-logic': KIND.accent,
	operational: KIND.primary
};

const RulesTab: React.FC<RulesTabProps> = ({ rules }) => {
	const [css] = useStyletron();

	if (!rules?.length) {
		return <div className={css({ padding: '24px', color: '#666' })}>No business rules associated with this config key.</div>;
	}

	return (
		<div
			className={css({
				padding: '16px',
				display: 'grid',
				gridTemplateColumns: '1fr 1fr',
				gap: '16px'
			})}>
			{rules.map((rule) => (
				<Card key={rule._id} overrides={{ Root: { style: { borderRadius: '8px' } } }}>
					<StyledBody>
						<div
							className={css({
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'flex-start',
								marginBottom: '8px'
							})}>
							<strong className={css({ fontSize: '15px' })}>{rule.ruleName}</strong>
							<RiskBadge level={rule.riskLevel} />
						</div>
						<p className={css({ color: '#555', margin: '0 0 12px 0', fontSize: '14px' })}>{rule.ruleDescription}</p>
						<div className={css({ display: 'flex', gap: '8px', alignItems: 'center' })}>
							<Tag closeable={false} kind={(CATEGORY_KIND[rule.ruleCategory] || KIND.primary) as any}>
								{rule.ruleCategory}
							</Tag>
							<span className={css({ fontSize: '12px', color: '#999' })}>Source: {rule.source}</span>
						</div>
					</StyledBody>
				</Card>
			))}
		</div>
	);
};

export default RulesTab;
